import React from 'react';
import PropTypes from 'prop-types';
import ObjectHelper from 'foundation/object-helper';
import LeaderboardWidget from 'components/leaderboard-widget/js/leaderboard-widget';
import { stateTypes } from 'components/leaderboard-widget/js/enums';

class LeaderboarCard extends React.Component {
    constructor(props) {
        super(props);

        this.players = [];
        this.numberOfCells = [
            { id: stateTypes.POSITION },
            { id: stateTypes.NAME },
            { id: stateTypes.TO_PAR, textTitle: 'to par' },
            { id: stateTypes.HOLE, textTitle: 'hole' },
            { id: stateTypes.TODAY, textTitle: 'today' }
        ];
    }

    getPlayers() {
        const { model } = this.props;
        let parsedData = [];

        if (model.dataJson) {
            try {
                parsedData = JSON.parse(model.dataJson);
            } catch (error) {
                console.log(error.message);
            }
        }

        return parsedData;
    }

    render() {
        const { datePublished } = this.props;

        if (this.props.model) {
            this.players = ObjectHelper.clone(this.getPlayers());
        }

        return (
            <LeaderboardWidget
                numberOfCells={this.numberOfCells}
                topPlayersToShowState={false}
                datePublished={datePublished}
                titleText={this.props.model.title}
                players={this.players}
                fullLeaderboardLinkText={this.props.model.fullLeaderboardLinkText}
                fullLeaderboardLink={this.props.model.targetUrl}
                targetsConfig={this.props.targetsConfig}
                patronLogo = {this.props.patronLogo}
                liveComponentLeaderboard = {true}
            />
        );
    }
}

LeaderboarCard.propTypes = {
    model: PropTypes.object
};

export default LeaderboarCard;
